import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SUGGESTIONS } from './chatConstants';
import { headerGradient } from './chatConstants';

export function InitialSuggestions({ isTyping, onSuggestionClick }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 0.5 }}>
            <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary', py: 1 }}>
                Ask Fae about your school's wellbeing data and insights.
            </Typography>
            {SUGGESTIONS.map((suggestion, i) => (
                <Paper
                    key={i}
                    elevation={0}
                    onClick={() => !isTyping && onSuggestionClick(suggestion.prompt)}
                    sx={{
                        p: 1.5,
                        pl: 1.75,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        borderRadius: 2,
                        border: '1px solid rgba(0,0,0,0.08)',
                        borderLeft: '3px solid var(--color-primary-dark, #0d47a1)',
                        bgcolor: '#fff',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                        cursor: isTyping ? 'not-allowed' : 'pointer',
                        transition: 'all 0.2s ease',
                        ...(isTyping && { opacity: 0.7, pointerEvents: 'none' }),
                        '&:hover': {
                            boxShadow: '0 4px 12px rgba(13, 71, 161, 0.2)',
                            borderColor: 'rgba(13, 71, 161, 0.3)',
                            transform: 'translateY(-1px)',
                        },
                    }}
                >
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            background: headerGradient,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        <HelpOutlineIcon sx={{ color: '#fff', fontSize: 20 }} />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="body2" fontWeight={600} color="text.primary">
                            {suggestion.text}
                        </Typography>
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: 'block', mt: 0.25 }}
                        >
                            Ask Fae
                        </Typography>
                    </Box>
                </Paper>
            ))}
        </Box>
    );
}
